import { ISerializable } from '@customTypes/common';

export interface ILifecycleEvent {
  module: string;
  eventInfo: string;
  timestamp: number;
}

type TValue = string | number | boolean | null | undefined;

export type TRawMetrics = Record<string, TValue>;

export enum ECommand {
  CONNECT_TO_ROOM = 'connectToRoom',
  MODULES_INFO_AVAILABLE = 'modulesInfoAvailable',
  MODULE_LIFECYCLE_EVENT_AVAILABLE = 'moduleLifecycleEventAvailable',
  CLIENT_CONNECTED = 'clientConnected',
  CLIENT_INFO_AVAILABLE = 'clientInfoAvailable',
  CLIENT_DISCONNECTED = 'clientDisconnected',
}

export type TModuleInfo = Record<string, TRawMetrics | TValue | TValue[]>;

export type TModulesInfo = Record<string, TModuleInfo>;

export type TMessage =
  | {
      command: ECommand.CONNECT_TO_ROOM;
      roomId: string;
    }
  | {
      command: ECommand.MODULES_INFO_AVAILABLE;
      payload: Record<string, TModuleInfo>;
    }
  | {
      command: ECommand.MODULE_LIFECYCLE_EVENT_AVAILABLE;
      event: ILifecycleEvent;
    }
  | {
      command: ECommand.CLIENT_DISCONNECTED;
    }
  | {
      command: ECommand.CLIENT_CONNECTED;
      clientInfo: ISerializable;
    }
  | {
      command: ECommand.CLIENT_INFO_AVAILABLE;
      clientInfo: ISerializable;
    };
